export class AuthUser {
  id: string;
  displayName?: string;
  mail: string;
  username: string;
  tenantId: string;

  constructor() {}
}
